import { render, staticRenderFns } from "./ExpiringOrder.vue?vue&type=template&id=00530ab1"
import script from "./ExpiringOrder.vue?vue&type=script&lang=js"
export * from "./ExpiringOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports